import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import Description from "../../Components/Description?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import * as Constants from "../../Constants?v=0.0.2";

import ActionRequiredImage from "../../Images/ActionRequiredImage.svg";

function ApplicationAccessApproval(props) {
  document.title = "myBooks | Application Access Approval";
  const environment = props.environment;
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (
      queryString.parse(window.location.search).token === undefined ||
      queryString.parse(window.location.search).token === ""
    ) {
      //history.push("myBooks/login");
    }
  }, [history, environment]);

  const callAPI = () => {
    setLoader(true);
    fetch(environment.loginAppAPI + Constants.approveSupportAccess, {
      method: "POST",
      body: JSON.stringify({
        approvalData: {
          supportToken: queryString.parse(window.location.search).token,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setLoader(false);
          setStep(2);
        },
        (error) => {
          console.log(error);
        }
      );
  };

  return (
    <div className="App col-12 d-flex align-items-center myBooks">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column margin-interaction-card">
              <div className="font-20-600 text-align-left">Action Required</div>
              <Description
                className="description"
                text="Need approval to access your account"
              ></Description>
              <img
                src={ActionRequiredImage}
                alt=""
                className="forget-password-image mt-3"
              />

              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 d-lg-flex d-block align-items-center">
            <div className="mx-auto margin-interaction-card interaction-card">
              <div className="d-flex flex-wrap justify-content-center pb-lg-3">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myBooks_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              <div className="min-height-250px mt-4 mb-5 my-lg-0">
                <h2 className="font-20-600 black">Authentication Required</h2>
                <p className="poppins-14 Color-9C9C9C text-left font-18">
                  Click Approve to provide access for the team. This access will
                  expire after 10 days. We don’t have access to create or modify
                  your Organizaion data.
                </p>
              </div>
              <button
                className="button d-flex flex-wrap align-items-center justify-content-center"
                onClick={
                  step === 1
                    ? callAPI
                    : () => {
                        history.push("/myBooks/login");
                      }
                }
              >
                {loader && <div className="spinner-border" role="status"></div>}
                {!loader && (
                  <>
                    <div className="mr-2">
                      {step === 1 && "Approve Access"}
                      {step === 2 && "Back to Sign In Page"}
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        fill="#fff"
                        d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                      />
                    </svg>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplicationAccessApproval;
